import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

const previewBackgroundStyles = css`
  background-color: var(--surface-decorative-purple-default);
`;

const previewTextStyles = css`
  color: var(--text-decorative-purple);
`;

const recapBackgroundStyles = css`
  background: var(--surface-decorative-teal-default);
`;

const recapTextStyles = css`
  color: var(--text-decorative-teal);
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LabelWrapper = styled.div<{ $isPreview?: boolean }>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  ${borderRadius.r2};
  max-width: 130px;
  height: 24px;

  ${({ $isPreview }) =>
    $isPreview ? previewBackgroundStyles : recapBackgroundStyles}
`;

export const Label = styled.p<{ $isPreview?: boolean }>`
  ${typographyV2.uiXs};
  white-space: nowrap;
  ${({ $isPreview }) => ($isPreview ? previewTextStyles : recapTextStyles)}
`;

export const MetadataText = styled.p`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;
